export default __webpack_public_path__ + "static/media/romero-rodrigues-modal.adfaaf55.jpg";